import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import CommuneGroupItem from './CommuneGroupItem.vue';


const __default__ = {
  name: 'NightCardList',
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  communesList: {
    type: Array,
    default: () => [],
  },
},
  setup(__props) {

const props = __props;



const getCommunesGroupItems = computed(() => {
  const communeGroups = (props.communesList as any[]).reduce((accumulator: any[], currentValue: any) => {
    const { Title, OutOfService, Slug } = currentValue;
    const dataToSet = {
      title: Title,
      isOutOfService: !!OutOfService,
      slug: Slug,
    };
    const firstLetter = Title[0].toLowerCase();
    const letterGroup = accumulator.find((item) => item.letter === firstLetter);
    if (letterGroup) {
      letterGroup.items.push(dataToSet);
    } else {
      const groupItem = {
        letter: firstLetter,
        items: [dataToSet],
      };
      accumulator.push(groupItem);
    }
    return accumulator;
  }, []);
  return communeGroups.sort((a: { letter: string }, b: { letter: string }) => {
    if (a.letter < b.letter) { return -1; }
    if (a.letter > b.letter) { return 1; }
    return 0;
  });
});

return { __sfc: true,props, getCommunesGroupItems, CommuneGroupItem }
}

})